// TFT tier colour and label helpers (Polish labels)

export const TIER_COLORS = {
  IRON: "#787878",
  BRONZE: "#A8765A",
  SILVER: "#A0A5A9",
  GOLD: "#E2B13C",
  PLATINUM: "#3E928D",
  EMERALD: "#27A656",
  DIAMOND: "#4A8CFF",
  MASTER: "#8A2BE2",
  GRANDMASTER: "#E84057",
  CHALLENGER: "#2DEBFF",
};

export const TIER_LABELS_PL = {
  IRON: "Żelazo",
  BRONZE: "Brąz",
  SILVER: "Srebro",
  GOLD: "Złoto",
  PLATINUM: "Platyna",
  EMERALD: "Szmaragd",
  DIAMOND: "Diament",
  MASTER: "Mistrz",
  GRANDMASTER: "Arcymistrz",
  CHALLENGER: "Pretendent",
};

const RANK_NUMERAL = { I: "I", II: "II", III: "III", IV: "IV" };

export function tierColor(tier) {
  if (!tier) return "#6E6A5E";
  return TIER_COLORS[tier.toUpperCase()] || "#6E6A5E";
}

export function tierLabel(tier, rank) {
  if (!tier) return "Bez rangi";
  const pl = TIER_LABELS_PL[tier.toUpperCase()] || tier;
  const apex = ["MASTER", "GRANDMASTER", "CHALLENGER"].includes(tier.toUpperCase());
  if (apex) return pl;
  const r = RANK_NUMERAL[(rank || "").toUpperCase()] || rank || "";
  return r ? `${pl} ${r}` : pl;
}

export const REGIONS = [
  { value: "euw", label: "EUW" },
  { value: "eune", label: "EUNE" },
  { value: "na", label: "NA" },
  { value: "kr", label: "KR" },
  { value: "br", label: "BR" },
  { value: "jp", label: "JP" },
  { value: "oce", label: "OCE" },
  { value: "tr", label: "TR" },
  { value: "lan", label: "LAN" },
  { value: "las", label: "LAS" },
];
